import React, { memo } from 'react'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import { InlineMessage } from 'transfix-ui/components/InlineMessage'
import { driverLocationsColumnOrder } from 'apps/user/constants/driverLocations'
import { LegacyTableRow as TableRow } from 'components/atoms'
import { FORMATS } from 'constants/datetime'

export const DriverLocationsRow = memo(({ driverLocations }) => {
  const {
    altitude,
    createdAt,
    deletedAt,
    latitude,
    longitude,
    phoneModel,
    phoneOs,
    phoneTimestamp,
    shipmentId,
    sourceType = '',
    speed,
    timezone,
  } = driverLocations || {}
  const date = moment.tz(phoneTimestamp, timezone).format(FORMATS.datetimeFormat)
  const processed = moment.tz(createdAt, timezone).format(FORMATS.datetimeFormat)
  const rogue = deletedAt ? <InlineMessage message='Marked as rogue ping' type='alert' /> : <p />
  const manual = sourceType === 'Manual' && <InlineMessage message='Manual ping' type='alert' />
  const eld = (sourceType?.toLowerCase() === 'eld' ||
    sourceType?.toLowerCase() === 'project_44') && <p>Project44</p>
  const oneTimeLocation = sourceType === 'One Time Location' && (
    <InlineMessage message='One time location ping' type='alert' />
  )
  const cells = {
    id: (
      <p>
        <a
          href={`${__ROOT__}/shipment-details/${shipmentId}?tab=scheduling`}
          target='_blank'
          rel='noopener noreferrer'>
          {shipmentId}
        </a>
      </p>
    ),
    source: manual || eld || oneTimeLocation || (
      <p>
        {phoneModel} {phoneOs}
      </p>
    ),
    date: <p>{date}</p>,
    coordinates: (
      <p>
        Lat: {latitude}
        <br />
        Long: {longitude}
      </p>
    ),
    altSpeed: (
      <p>
        Alt: {altitude}
        <br />
        Speed: {speed} m/s
      </p>
    ),
    notes: rogue,
    processed: <p>{processed}</p>,
  }
  return <TableRow columns={driverLocationsColumnOrder} cells={cells} />
})

DriverLocationsRow.propTypes = {
  driverLocations: PropTypes.shape({
    shipmentId: PropTypes.string,
    phoneModel: PropTypes.string,
    phoneOS: PropTypes.string,
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    horizontalAccuracy: PropTypes.string,
    altitude: PropTypes.string,
    verticalAccuracy: PropTypes.string,
    course: PropTypes.string,
    speed: PropTypes.string,
    phoneTimestamp: PropTypes.string,
    timezone: PropTypes.string,
    deletedAt: PropTypes.string,
    osTimestamp: PropTypes.string,
    transfixVersion: PropTypes.string,
    createdAt: PropTypes.string,
    sourceId: PropTypes.string,
    sourceType: PropTypes.string,
  }).isRequired,
}
